import { ProgramsService } from "./implementations/programs.service";

export default defineNuxtPlugin((nuxtApp) => {
  const programs = new ProgramsService(
    nuxtApp.$axios,
    nuxtApp.$config.public.sgApiUrl
  );

  return {
    provide: {
      programs: programs,
    },
  };
});
